import { Button, Dropdown, Icons, Search } from '@silverfort/sf-components';
import { downloadFile, httpGet } from '../../../components/utils';
import { HTTP_OPTIONS, PRIVILEGED_ACCOUNTS_FILTERS } from '@silverfort-nodelibs/common/utils/consts';
import { useEffect, useState } from 'react';

const MAX_SEARCH_LENGTH = 64;

const getPASReport = async () => {
    const reqUrl = '/privilegedAccounts/generatePasReport';
    const res = await httpGet(reqUrl, {});
    downloadFile(`/privilegedAccounts/downloadPasReport?fileName=${res.data.fileName}`);
};

const PrivilegedAccountsFilters = ({ selectedFilters, setSelectedFilters, onSearchChange }) => {
    const [groups, setGroups] = useState([]);

    const filters = { ...PRIVILEGED_ACCOUNTS_FILTERS };
    filters.group.options = groups;

    const searchGroupsAndOU = async (term) => {
        try {
            const escapedTerm = term?.trim() || '';

            const reqUrl = '/privilegedAccounts/searchGroupsAndOU';

            const res = await httpGet(reqUrl, {
                [HTTP_OPTIONS.REQ_OPTIONS]: {
                    params: { hideDeleted: true, asFilterData: true, term: escapedTerm }
                }
            });

            return res.data || [];
        } catch (e) {
            console.error('Failed to search groups for query ' + term, e);
        }
    };

    useEffect(() => {
        let isMounted = true;
        const fetchData = async () => {
            try {
                const groupsData = await searchGroupsAndOU();
                isMounted && setGroups(groupsData);
            } catch (e) {
                console.error('failed to load privileged accounts filter groups.', e);
            }
        };

        fetchData();
        return () => {
            isMounted = false;
        };
    }, []);

    filters.group.searchHandler = async (term) => {
        if (term.length <= MAX_SEARCH_LENGTH) {
            const groupsData = await searchGroupsAndOU(term);
            setGroups(groupsData);
        } else {
            console.error('search term too long');
        }
    };

    filters.group.onClose = async () => {
        setTimeout(async () => setGroups(await searchGroupsAndOU('')), 500);
    };

    return (
        <div className="h-8 flex items-center justify-between">
            <div className="flex items-center gap-2 flex-wrap">
                {Object.values(filters)
                    .filter((filter) => selectedFilters[filter.id])
                    .map((filter) => (
                        <Dropdown
                            {...filter}
                            items={filter.options}
                            key={filter.id}
                            variant="filter"
                            searchable="false"
                            selectedItems={selectedFilters[filter.id] || []}
                            removable={!!selectedFilters[filter.id]?.length}
                            onRemove={() => {
                                const newSelectedFilters = { ...selectedFilters };
                                delete newSelectedFilters[filter.id];
                                setSelectedFilters(newSelectedFilters);
                            }}
                            onChange={(val) => {
                                setSelectedFilters({ ...selectedFilters, [filter.id]: val });
                            }}
                        />
                    ))}
                {Object.values(filters)
                    .filter((filter) => !selectedFilters[filter.id])
                    .map((filter) => (
                        <Dropdown
                            {...filter}
                            items={filter.options}
                            key={filter.id}
                            variant="filter"
                            searchable="false"
                            selectedItems={selectedFilters[filter.id] || []}
                            removable={!!selectedFilters[filter.id]?.length}
                            onRemove={() => {
                                const newSelectedFilters = { ...selectedFilters };
                                delete newSelectedFilters[filter.id];
                                setSelectedFilters(newSelectedFilters);
                            }}
                            onChange={(val) => {
                                setSelectedFilters({ ...selectedFilters, [filter.id]: val });
                            }}
                        />
                    ))}
            </div>
            <div className="flex items-center gap-2">
                <Search
                    border={true}
                    placeholder="Search account name"
                    onChange={(val) => {
                        if (val.length <= MAX_SEARCH_LENGTH) {
                            onSearchChange(val);
                        } else {
                            console.error('search term too long');
                        }
                    }}
                />
                <Button iconRight={Icons.Download} onClick={getPASReport} />
            </div>
        </div>
    );
};

export default PrivilegedAccountsFilters;
